const settings = {
  btnSave: 'Save',
  off: 'off',
  btnRestoreDefault: 'Restore Default Settings',

  btnAdvance: {
    show: 'Show Advanced',
    hide: 'Hide Advanced',
  },

  general: {
    title: 'General',
    pageTitle: 'General Settings',
    groups: {
      general: {
        title: 'General',
        parameters: {
          timezone: {
            label: 'Time Zone',
            description: 'The system',
          },
          defaultLanguage: {
            label: 'Default Language',
            description:
              'Preferred language – will apply when switching site view, refreshing, or logging in, if no user preference is set.',
          },
          systemType: {
            label: 'System Type',
            description: 'Toggle between Imperial and Metric units to customize the display of distances in the system',
            options: {
              imperial: 'Imperial',
              metric: 'Metric',
            },
          },
          addressType: {
            label: 'Address Field Type',
            description:
              'Customize how addresses are filled. "Google" enables autofill from Google, "Location" auto-fills saved locations from the system\'s "Locations" module, and "Both" provides both options for user convenience',
            options: {
              both: 'Both',
              google: 'Google',
              location: 'Location',
            },
          },
          enableLocationTimezone: {
            label: 'Location-Based Timezone',
            description:
              'When enabled, the system resolves the timezone from the booking location instead of using the system default timezone.',
          },
        },
      },
      auth: {
        title: 'Auth',
        parameters: {
          twoFA: {
            label: 'Enforce Two-Factor Authentication (2FA)',
            description: 'When enabled, all users are required to perform two-factor authentication on new devices.',
          },
        },
      },
      booking: {
        title: 'Booking',
        parameters: {
          preventDuplications: {
            label: 'Reservation Duplication Warning',
            description:
              'Enable to receive a warning pop-up when filling a booking with identical details, or disable to turn off this alert.',
          },
          isWaitAndReturnEnabled: {
            label: 'Enable Wait & Return',
            description: '',
          },
        },
      },
      map: {
        title: 'Map',
        parameters: {
          mapStyle: {
            label: 'Map Tiles Style',
            description: 'Choose the tile imagery used on all maps across the platform',
            options: {
              lightDark: 'Light / Dark',
              streets: 'Streets',
              satellite: 'Satellite',
            },
          },
          mapServer: {
            label: 'Map Server',
            description: 'OSRM Map Server',
          },
          graphhopperEnabled: {
            label: 'Enable Graphhopper',
            description: 'When enabled, the system uses Graphhopper as the map server for routing. When disabled, OSRM is used.',
          },
          mapCenter: {
            label: 'Map Center',
            description: 'Set the default center point for the map view',
          },
          mapZoom: {
            label: 'Map Zoom',
            description: 'The default zoom for maps in the platform',
          },
        },
      },
    },
  },

  routing: {
    title: 'Routing',
    pageTitle: 'Routing Settings',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          sharedRideRatio: {
            label: 'Max Shared Time Ratio',
            description: 'Maximum allowed ratio between solo trip time and shared trip time (e.g., 1.5 = up to 50% longer than solo)',
          },
          sharedRideDifferenceLimit: {
            label: 'Max Extra Shared Time',
            description: 'Maximum extra minutes that can be added to the solo trip time when a passenger is in a shared ride',
          },
          maxSharedDistanceRatio: {
            label: 'Max Shared Distance Ratio',
            description:
              'Defines how much longer a shared ride is allowed to be compared to the solo distance. Example: If solo distance is 1 mile and the ratio is 1.2x, the shared ride for that passenger cannot exceed 1.2 miles',
          },
          maxTripStops: {
            label: 'Max Stops',
            description: 'Maximum stops locations per trip',
          },
          maxPickupStops: {
            label: 'Max Pickup Stops',
            description: 'Maximum number of pickup stops per trip',
          },
          maxDropoffStops: {
            label: 'Max Dropoff Stops',
            description: 'Maximum number of dropoff stops per trip',
          },
          maxTripDuration: {
            label: 'Max Trip Duration',
            description: 'Maximum duration of a trip in minutes',
          },
          maxSinglePassengerTime: {
            label: 'Max Single Passenger Trip Time',
            description: '',
          },
          maxPassengers: {
            label: 'Max Passengers',
            description: 'Maximum number of passengers in the entire trip',
          },
          maxPassengersAtOnce: {
            label: 'Max Passengers At Once',
            description:
              'Maximum number of passengers allowed to be occupied at the same time (a seat will be free/used on passengers drop/pickup)',
          },
          tripBoardingTime: {
            label: 'Boarding Time',
            description: 'The time it takes to pick up a passenger on their stop (This parameter will impact overall trip duration)',
          },
          subsequentPickTime: {
            label: 'Secondary Boarding Time',
            description:
              "When the setting is off, boarding times follow the general 'Boarding Time' setting. Activating this setting customizes boarding times specifically for non-first passengers",
          },
          tripDropOffTime: {
            label: 'Drop-off Time',
            description: 'The time it takes to drop a passenger on their stop (This parameter will impact overall trip duration)',
          },
          subsequentDropOffTime: {
            label: 'Secondary Drop-off Time',
            description:
              "When the setting is off, boarding times follow the general 'Drop-off Time' setting. Activating this setting customizes drop-off times specifically for non-first passenger",
          },
          maxBoardingDelay: {
            label: 'Max Boarding Delay',
            description: 'Maximum number of minutes a driver can be late for the pickup time set in the reservation Number',
          },
          maxBoardingEarly: {
            label: 'Max Boarding Early',
            description: 'Maximum number of minutes a driver can get early relative to the pickup time set in the reservation',
          },
          onlyPrivate: {
            label: 'Only Private',
            description: 'Make all trips private',
          },
        },
      },

      advanced: {
        title: 'Advanced',
        parameters: {
          tripsJoinMode: {
            label: 'Try Join',
            description: 'Decide if the engine will try to join new reservations to existing trips DontJoin = 0, TryJoin = 1, OnlyJoin = 2',
            options: {
              dontJoin: "Don't Join",
              tryJoin: 'Try Join',
              onlyJoin: 'Only Join',
            },
          },
          maxJoinRadius: {
            label: 'Try Join - Radius',
            description: 'Defines the maximum radius (KM) we try to look for existing trips to join a reservation to',
          },
          maxJoinTimeRange: {
            label: 'Try Join - Time Range',
            description: 'Existing trips that are further away from this limit will be considered for try join',
          },
          maxReservationsAtOnce: {
            label: 'Max Reservations At Once',
            description: 'Maximum number of reservations allowed to be in the vehicle at the same time.',
          },
          minReservationDistance: {
            label: 'Min Reservation Distance',
            description:
              'Minimum distance (in meters) a reservation should have between pickup and drop-off location in order to be included in the route. Reservation with a smaller distance than that would be completly ignored by the engine. Number',
          },
          maxEmptyTripTime: {
            label: 'Max Empty Time',
            description: 'Maximum number of minutes a trip is allowed to be empty between stops',
          },
          maxDropOffEarly: {
            label: 'Max Drop-off Early',
            description: 'Maximum number of minutes a driver can get early relative to the drop-off time set in the reservation',
          },
          maxDropOffDelay: {
            label: 'Max Drop-off Delay',
            description: 'Maximum number of minutes a driver can be late for the drop off time set in the reservation Number',
          },
          pickPhaseRadius: {
            label: 'Pick Radius Range',
            description:
              'Defines the maximum allowed distance (in kilometers or miles) between the first pickup and any subsequent pickups. Bookings with pickups outside this radius should not be combined.',
          },
          pickPhaseMinutes: {
            label: 'Pick Minutes Range',
            description:
              'Defines the maximum time (in minutes) allowed between the first pickup and any subsequent pickups. If the time difference exceeds this threshold, bookings should not be combined.',
          },
          groupWaitAndReturn: {
            label: 'Group Wait & Return',
            description:
              '• Off: No grouping at all; outbound and return trips are routed separately.\n\n• Individual Pair: Group each outbound and return trip together in a single trip.\n\n• Multiple Pairs: Group multiple outbound and return pairs together, allowing several wait-and-return pairs to be routed in a single trip.',
            options: {
              off: 'Off',
              individualPair: 'Individual Pair Grouping',
              multiplePairs: 'Multiple Pair Grouping',
            },
          },
          pickupAllBeforeDropping: {
            label: 'Pick All',
            description: 'When set to true, the trip will first pick up all passengers and then start with dropping everyone off',
          },
          waitForBoardingTime: {
            label: 'Wait For Boarding Time',
            description: 'When reaching a stop, the driver will wait until the exact pick-up time, if needed.',
          },
          sortStopsByPickupTime: {
            label: 'Sort By Pickup Time',
            description: 'When set to true, all stops in the trip will be ordered by the pick-up time only, and not geographically.',
          },
          balanceDepartureTime: {
            label: 'Normalize Departure',
            description: "Adjusts the departure time so that passenger's waiting times will be balanced.",
          },
          angleDuration: {
            label: 'Angle Duration',
            description: 'Avoids routing of legs that are Angle Duration minutes or longer and are in an angle more than Angle.',
          },
          angleMax: {
            label: 'Angle Max',
            description: 'Avoids routing of legs that are Angle Duration minutes or longer and are in an angle more than Angle.',
          },
          allowActiveTripsRouteChanges: {
            label: 'Add Bookings to In-Route Trips',
            description: "Enable 'Try Join' bookings (e.g., Will Calls) for In-Route trips alongside New trips.",
          },
          rerouteTripOnBookingUpdate: {
            label: 'Reroute Trip on Booking Update',
            description:
              'When on, an edited booking stays on its trip. A trip in status New is routed again: the booking stays if it still fits with the other bookings, and its driver stays if still eligible. A trip in status Sent/Approved/In-Route is also routed again, so its stops can get a new order and new times, and all its bookings stay. Trips in status Done/Canceled are never changed. When off, the edited booking is removed from its trip and goes back to status New, unless it is Picked/Dropped/No-Show - then it stays and its trip is routed again with it.',
          },
          vrpRunningTime: {
            label: 'VRP Running Time',
            description:
              'Time limit for the optimization to try and improve results, longer runs leave room to explore more possibilities.',
          },
          editOnMap: {
            label: 'Edit on Map',
            description: 'Allows users to manually reorder stops within a trip by dragging them on the map.',
          },
          consistentPassengerRouting: {
            label: 'Consistent Passenger Routing',
            description:
              'Ensures that the same group of passengers always follows the same route to and from the specific address, optimizing travel efficiency and minimizing confusion.',
          },
          sameDriverForGroup: {
            label: 'Same Driver for Group',
            description:
              'Assigns the same driver to transport the group of passengers for both pick-up and drop-off, providing familiarity and consistency for passengers.',
          },
          routingMode: {
            label: 'Routing Mode',
            description: '',
            options: {
              default: 'Default',
              hClustering: 'H-Clustering',
              vrp: 'VRP',
            },
          },
          defaultWillCallTime: {
            label: 'Will Call Offset Default',
            description: 'Add X minutes to Will Call offset logic as default when there is no Will Call–related attribute',
          },
          enableWillCallTime: {
            label: 'Will Call Time Enabled',
          },
        },
      },

      sameAreaLocation: {
        title: 'Same Zone / Location',
        parameters: {
          mergeReservationsByBoardingArea: {
            label: 'Same Pickup Zone',
            description: 'Bookings will be grouped together only if the pick-up location is in the same polygon.',
          },
          mergeReservationsByBoardingLocation: {
            label: 'Same Pickup Location',
            description: 'Bookings will be grouped together only if the pick-up location is the same.',
          },
          mergeReservationsByDropArea: {
            label: 'Same Drop-off Zone',
            description: 'Bookings will be grouped together only if the drop-off location is in the same polygon.',
          },
          mergeReservationsByDropLocation: {
            label: 'Same Drop-off Location',
            description: 'Bookings will be grouped together only if the drop-off location is the same.',
          },
          onlyGroupExactLocations: {
            label: 'Same Pickup Or Drop-off Location',
            description: 'Bookings will be grouped together only if the pickup or drop-off locations are the same.',
          },
          snapToLocation: {
            label: 'Snap To Location',
            description:
              'Automatically snap booking origin or destination to the closest known location from our internal locations management module, if it is within the snapToLocation radius. Value is in meters/foot based on your system type setting format.',
          },
          sameFlightNumber: {
            label: 'Same Flight Number',
            description: 'Bookings will be grouped together only if the flight number is the same.',
          },
        },
      },

      evs: {
        title: 'EV’s',
        parameters: {
          minimalBatteryThreshold: {
            label: 'Minimum Battery Threshold',
            description:
              'This is the critical battery percentage that you do not want the system to go below during your journey. For example, if set to 30%, the system will aim to keep your battery above this level.',
          },
        },
      },

      reservationClusters: {
        title: 'Reservation Clusters',
        parameters: {
          isClusteringEnabled: {
            label: 'Clustering',
            description: 'Defines whether or not reservations clustering algorithms are enabled or not.',
          },
          clusterSnapTo: {
            label: 'Mode',
            description: 'Defines whether or not a cluster center address should be changed with a known road or a bus station',
            options: {
              address: 'Address',
              busStop: 'Bus Stop',
            },
          },
          clusterReservationsRadius: {
            label: 'Diameter',
            description: 'In what diameter to start combine reservation together into one pickup/drop spot',
          },
          clusterSnapMaxDistance: {
            label: 'Maximum Distance',
            description:
              'Maximum distance (in KM/Miles according to the defined system) in which cluster center address could be modified for a better location',
          },
          distanceType: {
            label: 'Distance Type',
            description: 'Defines whether Distance to cluster will be by Air Distance or Walking Distance',
            options: {
              airDistance: 'Air Distance',
              walkingDistance: 'Walking Distance',
            },
          },
          snapToShapeRatio: {
            label: 'Priority Stops/Clusters by Air Distance',
            description:
              "The system will attempt to create additional stops along the route if the passenger's air distance is shorter than the selected ratio",
          },
          snapToShapeUnite: {
            label: 'Minimum Distance Between Generated Stops',
            description: 'Minimum distance between created stops.',
          },
          maxPassengersInCluster: {
            label: 'Max Number Of Passengers in Cluster',
            description:
              'Maximum number of passengers allowed in a cluster. This setting remains editable even when clustering is disabled.',
          },
          keepVrpClusters: {
            label: 'Keep VRP Clusters',
            description:
              'When enabled, VRP output remains clustered. When disabled, VRP clusters are split into individual reservations for rerouting.',
          },
        },
      },

      smoothRoute: {
        title: 'Smooth Route',
        parameters: {
          smoothRouteEnabled: {
            label: 'Smooth Route',
            description:
              'Defines whether or not a cluster center address should be changed with a known road or a bus station or by Smooth Route.',
          },
          smoothRouteRadius: {
            label: 'Smooth Route Radius',
            description:
              'Defines the maximum walking distance (in meters) that a passenger may be required to walk when “Smooth Route” is enabled. This setting only takes effect if “Smooth Route” is turned on.',
          },
        },
      },

      traffic: {
        title: 'Traffic',
        parameters: {
          trafficRouteEnabled: {
            label: 'Edit traffic settings',
            modalHeader: 'Warning: Sensitive Traffic Settings',
            modalBody:
              'You are about to edit advanced traffic configuration settings. These values directly affect how routes are calculated and may significantly alter system behavior. Please proceed only if you fully understand the implications. To confirm, type "traffic" below and click "Confirm".',
          },
          minTraffic: {
            label: 'Minimum',
            description: 'Minimal ratio between the traffic duration and map server duration',
          },
          baseTraffic: {
            label: 'Base',
            description: 'Multiply all calculated durations by a base ratio (X). Higher values increase estimated travel times.',
          },
          hourTraffic: {
            label: 'Hour',
            description:
              'An array of 24 hourly ratios (00:00–23:59). Each value adjusts trip duration multipliers based on the hour of the day.',
          },
        },
      },
    },
  },

  assignment: {
    title: 'Driver Assignment',
    pageTitle: 'Driver Assignment Settings',
    groups: {
      base: {
        title: 'Base',
        parameters: {
          distanceFromTripScore: {
            label: 'Distance',
            description:
              'Give higher priority if you wish to increase the chances that the driver that is the closest to the trip will be assigned.',
          },
          timeFromTripScore: {
            label: 'Time',
            description:
              'Give higher priority if you wish to increase the chances that the driver that can get fastest to the starting point will be assigned.',
          },
          gapTimeScore: {
            label: 'Idle',
            description:
              'A higher priority will increase the chances that a driver whos waiting for his next job the most time will be assigned.',
          },
          ifTripDone: {
            label: 'Number of Trips',
            description:
              'The higher the priority the higher the chances that someone that already assinged will be assigned again. Give lower priority to balance the trips between active drivers and high prioirty to have the least amount of drivers necessary.',
          },
          perTripDone: {
            label: 'Per Completed Trip',
            description: "The higher the priority, the more each completed trip increases the driver's chances of being assigned again.",
          },
          accumulatedSalaryScore: {
            label: 'Earnings',
            description:
              'Give a high prioirty if you wish to balance the amount of drivers based on their salaries (Using the most drivers). Give a low prioirty if you wish to use the least amount of drivers.',
          },
          algorithmCode: {
            label: 'Algorithm Code',
            options: {
              dateOrdering: 'Date Ordering',
              dynamicOrdering: 'Dynamic Ordering',
            },
          },
          driverAssignmentStrategy: {
            label: 'Driver Assignment Strategy',
            options: {
              minimumFleetUsage: 'Minimum Fleet Usage',
              balanceAvailableDrivers: 'Balance - Available drivers',
              balanceMinimumRequiredDrivers: 'Balance - Minimum required drivers',
            },
          },
        },
      },

      limits: {
        title: 'Limits',
        parameters: {
          maxTripsPerDriver: {
            label: 'Max Trips',
            description: 'The maximum amount of trips a driver could be assigned to on a given request.',
          },
          maxAccumulatedSalary: {
            label: 'Max Price',
            description:
              'The maximum sum of salary a driver could be making in the process of assignment (and then other drivers will be prioritized)',
          },
        },
      },

      advanced: {
        title: 'Advanced Settings',
        parameters: {
          distanceFromHomeScore: {
            label: 'Distance From Home',
            description: 'If you wish to keep drivers close to home (their starting location) you should give a high priority',
          },
          nextTripDistanceScore: {
            label: 'Distance From Next Trip',
            description:
              "When we 'fill holes' in the middle of a driver's plan for the day, we wish to get him closer to his next future trip's departure.So, for each meter away from his upcoming trip, his score for the current considered trip will be lowered.",
          },
          idleBonusMinutes: {
            label: 'Idle Bonus Minutes',
            description: 'Period that the driver needs to stay idle to receive the ${}',
          },
          idleBonusScore: {
            label: 'Idle Bonus Score',
            description: 'The amount of points added to driver score after being idle for ${} minutes.',
          },
          scorePerEmptySeats: {
            label: 'Per Empty Seat',
            description:
              'Use this setting to specify your preference for minimizing empty seats in the vehicle (The more negative the value, the stronger the avoidance).',
          },
          assignPriorityBonusMax: {
            label: 'Custom Rules Priority Bonus – Maximum',
            description: 'Maximum score awarded to the highest-priority attribute when assigning trips',
          },
          assignPriorityBonusMin: {
            label: 'Custom Rules Priority Bonus – Minimum',
            description: 'Minimum score awarded to the lowest-priority attribute when assigning trips',
          },
          areaMatchScore: {
            label: 'Zone Match',
            description:
              "The higher the priority, the more likely a driver that belongs to the trip's zone will be assigned. If you wish to fully restrict assignment for drivers from the same zone as the trip, the give it the highest priorty.",
          },
          scorePerVehicleCost: {
            label: 'Cost Per Vehicle',
            description: '',
          },
          perAssignmentScore: {
            label: 'Per Assignment Score',
            description:
              'Adds a score for every trip assigned to a driver. Higher values will discourage assigning multiple trips to the same driver.',
          },
          perLoadedDistance: {
            label: 'Per Loaded Distance',
            description:
              'Adds a score based on the distance of trips with passengers (loaded miles). Higher values prioritize shorter trips and reduce total loaded distance.',
          },
          isAssignBlocked: {
            label: 'Block Auto Assign',
            description: 'When Auto-Assign is turned off, selected profiles will not be automatically assigned',
          },
          assignBlockedProfiles: {
            label: 'Blocked Profiles',
            description: 'Choose which profiles should not be automatically assigned by the platform',
          },
          assignBlockedAttributes: {
            label: 'Blocked Attributes',
            description: 'Choose which attributes should not be automatically assigned by the platform',
          },
          allowFlexibleTimes: {
            label: 'Allow Flexible Times',
            description:
              'Optimize driver assignments and reduce vehicle usage by modifying trip departure times while adhering to Max Boarding Delay and Max Boarding Early rules.',
          },
          unassignOnVehicleChange: {
            label: 'Disable unassign driver on vehicle change',
            description:
              'Changing a driver to another vehicle with matching “Driver/Vehicle-Booking Attribute Matching” attributes will not automatically unassign the Driver’s trip.',
          },
          consistentSupplier: {
            label: 'Consistent Supplier',
            description:
              'The system will assign drivers from the same supplier to a passenger’s bookings within a single day, disregarding driver limitations.',
          },
          assignBySupplier: {
            label: 'Assign By Supplier',
            description: '',
          },
          supplierPriorityMode: {
            label: 'Supplier Order',
            description: '',
            options: {
              byRank: 'By Rank',
              byTier: 'By Tier',
            },
          },
          shiftAllocationWeight: {
            label: 'Driver Availability',
            description: 'The amount of points added to driver score per shift duration',
          },
        },
      },

      driverShifts: {
        title: 'Driver Shifts',
        parameters: {
          ignoreDriverShifts: {
            label: 'Ignore Driver Shifts',
            description: 'Driver assignment process take driver shifts into account',
          },
          startShiftWithTrip: {
            label: 'Start Shift With Trip',
            description:
              "Assigns drivers to trips at the start of their shift without factoring in travel time to the first pickup. Drivers are responsible for reaching the initial pickup location promptly at the shift's start time",
          },
          maxShiftHours: {
            label: 'Shift Max Time',
            description:
              'The maximum length (in hours) of a driver shift. The engine wont let a driver be considered active more than this amount of hours.',
          },
          shiftGap: {
            label: 'Shift Gap',
            description: 'Set the mandatory break duration between consecutive shifts',
          },
          driverRestAfterTrip: {
            label: 'Enforce Break',
            description: 'Drivers are prompted to take a rest after each trip.',
          },
          ignoreDropoffTime: {
            label: 'Ignore Drop-Off Time',
            description: 'The system will assign trips to drivers even if the drop-off time falls outside their availability.',
          },
          shiftBuffer: {
            label: 'Shift Buffer',
            description: 'Allow assignment of trips that end up to X minutes after the shift ends.',
          },
        },
      },

      mobileApp: {
        title: 'Driver Shifts App',
        parameters: {
          allowShiftCreation: {
            label: 'Allow Shift Creation',
            description: 'Enable drivers to create new shifts in their schedule.',
          },
          allowBreaksInShifts: {
            label: 'Allow Breaks in Shifts',
            description: 'Permit drivers to include break periods within their shifts.',
          },
          enableShiftDeletion: {
            label: 'Allow Shift Deletion',
            description: 'Allow drivers to delete their scheduled shifts if needed.',
          },
          minimumShiftCancellationNotice: {
            label: 'Minimum Shift Cancellation Notice',
            description: 'Set the minimum required time before a shift starts for a driver to cancel it.',
          },
          maxShiftAvailability: {
            label: 'Max Shift Availability',
            description: 'Define the longest availability time slot a driver can set for themselves.',
          },
          enableRecurringShifts: {
            label: 'Enable Recurring Shifts',
            description: 'Allow drivers to create recurring shifts on a custom date range.',
          },
        },
      },

      virtualReal: {
        title: 'Virtual vs Real',
        parameters: {
          assignmentType: {
            label: 'Assignment Type',
            description: 'Default assignment mode (Actual Drivers vs Virtual Drivers)',
            options: {
              virtual: 'Virtual',
              real: 'Real',
            },
          },
          addVirtualDrivers: {
            label: 'Fill with Virtual Drivers',
            description:
              "Automatically assigns virtual drivers to trips when there's a shortage of available drivers. Helps estimate fleet requirements by simulating additional drivers to cover the workload",
          },
          defaultCarLocation: {
            label: 'Default Car Location',
            description: "The default start location to be considered for a vehicle/driver if don't has its own.",
          },
          defaultCarSeats: {
            label: 'Default Seats',
            description: 'Default number of seats to be considered for a vehicle if not defined.',
          },
        },
      },
    },
  },

  distribution: {
    title: 'Distribution',
    pageTitle: '',
    groups: {
      base: {
        title: 'Fleets KPIs weight',
        parameters: {
          onTimePerformance: {
            label: 'On-Time Performance',
            description: '',
          },
          noShowRate: {
            label: 'No Show Rate',
            description: '',
          },
          cancellationRate: {
            label: 'Cancellation Rate',
            description: '',
          },
          acceptanceRate: {
            label: 'Acceptance Rate',
            description: '',
          },
          responseTime: {
            label: 'Response Time',
            description: '',
          },
          costEfficiency: {
            label: 'Cost Efficiency',
            description: '',
          },
        },
      },
    },
  },
  advancedSettingsPopups: {
    maxDurationByDistance: {
      title: 'Configure Max Duration by Distance',
      form: {
        fields: {
          startKm: 'From ({{unit}})',
          endKm: 'To ({{unit}})',
          durationMinutes: 'Max Duration (min)',
        },
        btnAddRange: 'Add Range',
        btnSubmit: 'Save',
        btnClose: 'Close',
      },
    },
  },
};

export default settings;
